import { render, staticRenderFns } from "./ImageNavigationButtons.vue?vue&type=template&id=5475f712"
import script from "./ImageNavigationButtons.vue?vue&type=script&lang=js"
export * from "./ImageNavigationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports